import React, { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';

// Replace with your publishable key
const stripePromise = loadStripe('pk_live_51Hdvs3AZWL3dcHQpbrdC1tHWo9i7vcYEhQDmkLUODb8l4XjoWKONcNkqa2pH7BAOg5GN6MTLqCjNb9d2aJDcC66300qlAUJ3pw');

interface StripeCheckoutProps {
  planType: 'weekly' | 'monthly' | 'lifetime';
  productName: string;
  onSuccess: () => void;
  onCancel: () => void;
  onError?: (error: string) => void;
}

const StripeCheckout: React.FC<StripeCheckoutProps> = ({ 
  planType, 
  productName,
  onSuccess, 
  onCancel, 
  onError 
}) => {

  const handleStripeCheckout = async () => {
    try {
      const stripe = await stripePromise;
      if (!stripe) throw new Error('Stripe failed to load');

      const response = await fetch('/tryCreateCheckoutSession', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          planType,
          productName,
          successUrl: `${window.location.origin}/user-panel?success=true&product=${encodeURIComponent(productName)}&plan=${encodeURIComponent(planType)}`,
          cancelUrl: `${window.location.origin}/products/rust`,
        }),
      });

      // if (!response.ok) {
      const {sessionId} = await response.json();
      if (sessionId === 'error') {
        throw new Error('Failed to create checkout session');
        return;
      }
        
      // }

      // const { sessionId } = await response.json();
      
      // Redirect to Stripe Checkout
      const { error } = await stripe.redirectToCheckout({
        sessionId,
      });

      if (error) {
        onError?.(error.message || 'Failed to redirect to checkout');
      }
    } catch (err) {
      onError?.((err as Error).message || 'Failed to initialize checkout');
    }
  };

  // Call handleStripeCheckout immediately when the component mounts
  React.useEffect(() => {
    handleStripeCheckout();
  }, []); // Empty dependency array means this runs once on mount

  return (
    <>
      
    </>
  );
};

export default StripeCheckout; 